<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    width="500"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>เลือกร้านค้าตัวแทน</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px">
        <v-list two-line v-if="list.length > 0">
          <template v-for="(item, index) in list">
            <v-list-item :key="index" style="border-bottom: 1px solid #efefef">
              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{ item.name }}</strong>
                </v-list-item-title>
                <v-list-item-subtitle>{{
                  item.formatted_address
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  outlined
                  small
                  color="primary"
                  ripple
                  @click="onSelected(item)"
                  >เลือก</v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
        <div class="text-center my-8" v-else>ไม่มีข้อมูล</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from "../services";
import { monthList } from "../utils/Constants";
import moment from "moment";

export default {
  name: "dc-dialog",
  props: {
    order_reference: { default: null },
    showDialog: { default: false },
  },
  data() {
    return {
      loading: false,
      isPass: false,
      isError: false,
      list: [],
    };
  },
  computed: {
    show: {
      get() {
        if (this.showDialog) {
          Service.Shop.gets({ level: "dc" }).then((res) => {
            this.list = res.data;
          });
        }
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    onSelected(item) {
      Service.Order.updateShop(this.order_reference, {
        shop_id: item.shop_id,
      }).then((res) => {
        if (res.success) {
          this.$emit("close", true);
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
